/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Pcrinput_Name1Inputs */

const en_resources_pcrinput_name1 = /** @type {(inputs: Resources_Pcrinput_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCR input`)
};

const fr_resources_pcrinput_name1 = /** @type {(inputs: Resources_Pcrinput_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisie PCR`)
};

const es_resources_pcrinput_name1 = /** @type {(inputs: Resources_Pcrinput_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introducir PCR`)
};

const de_resources_pcrinput_name1 = /** @type {(inputs: Resources_Pcrinput_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCR eingeben`)
};

const nl_resources_pcrinput_name1 = /** @type {(inputs: Resources_Pcrinput_Name1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCR invoeren`)
};

/**
* | output |
* | --- |
* | "PCR input" |
*
* @param {Resources_Pcrinput_Name1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_pcrinput_name1 = /** @type {((inputs?: Resources_Pcrinput_Name1Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Pcrinput_Name1Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_pcrinput_name1(inputs)
	if (locale === "fr") return fr_resources_pcrinput_name1(inputs)
	if (locale === "es") return es_resources_pcrinput_name1(inputs)
	if (locale === "de") return de_resources_pcrinput_name1(inputs)
	return nl_resources_pcrinput_name1(inputs)
});
export { resources_pcrinput_name1 as "resources.pcrInput.name" }